export const isServerSide = (): boolean => typeof window === 'undefined';
